import { Character, ConsumerMedia, Group } from "@/src/payload-types";
import React from "react";
import RelationLink from "@/src/components/RelationLink";

export const getGroupLink = (group: Group) => (
    <RelationLink relationTo={"groups"} id={group.slug.toString()} label={group.name} />
);

export const getCharacterLink = (char: Character) => (
    <RelationLink relationTo={"characters"} id={char.slug} label={char.name} />
);

export const getConsumerMediaLink = (consumerMedia: ConsumerMedia, label?: string) => (
    <RelationLink
        relationTo={"consumerMedia"}
        id={consumerMedia.slug.toString()}
        label={label || consumerMedia.title}
    />
);

export function getNextImageUrl(src: string, width: number, height: number, quality: number) {
    const encoded = encodeURIComponent(src);
    return `/_next/image?url=${encoded}&w=${width}&h=${height}&q=${quality}`;
}

export function getBlobUrl(relativeUrl: string): string {
    if (!relativeUrl) {
        return "";
    }
    const base = process.env.NEXT_PUBLIC_BLOB_BASE_URL!;
    // "/api/media/file/vulkan_avatar-144x144.avif" → "vulkan_avatar-144x144.avif"
    const filename = relativeUrl.split(/\/api\/[^/]+\/file\//)[1];
    return `${base}/${filename}`;
}

export function getNextCoverUrl(src: string) {
    return getNextImageUrl(src, 300, 400, 80);
}

export function getNextSplashUrl(src: string) {
    return getNextImageUrl(src, 1280, 720, 80);
}
